import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class ApiInterceptorInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Pastikan hanya request ke /api/ yang diubah
    if (req.url.startsWith('/api/')) {
      const apiReq = req.clone({
        url: `${environment.apiUrl}${req.url.replace('/api', '')}`,
        setHeaders: {
          'x-api-key': environment.apiKey
        }
      });
      return next.handle(apiReq);
    }
    return next.handle(req);
  }
}
